import React from 'react';
// import DataTable from 'react-data-table-component';
// import MUIDataTable from "mui-datatables";
// import axios from 'axios';
import { confirmAlert } from 'react-confirm-alert'; // Import
import DocumentListView from "../views/DocumentList";
import $ from 'jquery'

let userRole;
const inpersonateFlag = localStorage.getItem("inpersonate");
class Documents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: '',
      isFilePicked: false,
      documentName: '',
      documentVersion: '',
      fileName: '',
      errordocumentName: false,
      errordocumentVersion: false,
      errordocumenttype: false,
      errorfile: false,
      errorfilesize: false,
      isdocumentLoader: false,
      issucessMEssage: '',
      errorstatuscode: '',
      table: {
        data: [],
        loading: true,
        totalRows: 0,
        perPage: 1,
      }

    }
    this.handledocumentDownload = this.handledocumentDownload.bind(this);
    this.handledeleteDocument = this.handledeleteDocument.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleactiveDocument = this.handleactiveDocument.bind(this);
  }
  componentDidMount() {
    const get_token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    userRole = localStorage.getItem("userRole");

    if (!this.props.documents) {

      if (1 === this.props.SelectedTab) {
        const requestOptions = {
          method: "GET",
          mode: "cors",
          headers: {
            'Authorization': 'Bearer' + get_token,
          },
        };

        this.setState({ isdocumentLoader: true });
        fetch(`./wp-json/asd/api/documents`, requestOptions)
          .then((response) => {
            if (response.ok) {
              return response.json();
            } else if (response.status === 401 || response.status === 403) {
              this.setState({
                issucessMEssage: "You have been logged out, please login again", isdocumentLoader: false, errorstatuscode: '',
              });
              localStorage.removeItem("token");
              window.location.href = "/asd-login";
            } else if (response.status === 404) {
              this.setState({
                issucessMEssage: "There are no documents to display", isdocumentLoader: false, errorstatuscode: '404',
              });
              return false
            } else if (response.status === 500) {
              this.setState({
                issucessMEssage: "Oh no! Something bad happened. Please come back later.. ", isdocumentLoader: false, errorstatuscode: '',
              });
              return false
            } else {
              this.setState({
                issucessMEssage: "Something went's wrong. Please try again later", isdocumentLoader: false, errorstatuscode: '',
              });
            }
          })
          .then(userData => {

            if (userData.data != null) {
              this.setState({
                table: {
                  data: userData.data,
                  loading: false,
                  totalRows: parseInt(userData.total)
                },
                isdocumentLoader: false,
                errorstatuscode: '',
              });
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          })
      }

    }
  }


  handlePageChange = async page => {
    const get_token = localStorage.getItem("token");
    const reportRequestOptions = {
      method: 'GET',
      mode: "cors",
      headers: {
        'Authorization': 'Bearer' + get_token,
      },

    }
    this.setState({ isdocumentLoader: true });
    fetch(`./wp-json/asd/api/documents?page=` + page, reportRequestOptions)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else if (response.status === 401 || response.status === 403) {
          this.setState({
            issucessMEssage: "You have been logged out, please login again", isdocumentLoader: false, errorstatuscode: '',
          });
          localStorage.removeItem("token");
          window.location.href = "/asd-login";
        } else if (response.status === 404) {
          this.setState({ issucessMEssage: "There are no documents to display", isdocumentLoader: false, errorstatuscode: '404', });
          return false
        } else if (response.status === 500) {
          this.setState({ issucessMEssage: "Oh no! Something bad happened. Please come back later.. ", isdocumentLoader: false, errorstatuscode: '' });
          return false
        } else {
          this.setState({ issucessMEssage: "Something went's wrong. Please try again later", isdocumentLoader: false, errorstatuscode: '', });
        }
      })
      .then(userData => {

        if (userData.data != null) {
          this.setState({
            table: {
              data: userData.data,
              loading: false,
              totalRows: parseInt(userData.total)
            },
            isdocumentLoader: false,
            errorstatuscode: '',
          });
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      })
  }


  onChangeHandler = event => {
    let file = event.target.files[0];
    console.log(file);
    let filename = event.target.files[0].name;
    var reg = /(.*?)\.(pdf)$/;
    var fileext = event.target.files[0].name;
    if (!fileext.match(reg)) {
      this.setState({
        selectedFile: '',
        fileName: '',
        errorfileext: true,
        errorfilesize: false,
      });
    } else if (file.size == 0) {
      this.setState({
        selectedFile: '',
        fileName: '',
        errorfilesize: true,
        errorfileext: false,
      });
    } else {
      this.setState({
        selectedFile: event.target.files[0],
        fileName: filename,
        errorfileext: false,
        errorfilesize: false

      });
      $('.browse-btn').css('display', 'none');
      $('.subscribe-btn').css('display', 'inline-block');
      $('.close-btn').css('display', 'inline-block');

    }
    if (filename != '') {
      this.setState({ errorfile: false });
    }
    else {
      this.setState({ errorfile: true });
    }

  }

  clearFile = event => {

    this.setState({
      selectedFile: '',
      fileName: '',
      errorfileext: false

    });
    $('#upload').val(null);
    $('.browse-btn').css('display', 'inline-block');
    $('.subscribe-btn').css('display', 'none');
    $('.close-btn').css('display', 'none');
  }

  onClickHandler = () => {
    const formData = new FormData();
    const get_token = localStorage.getItem("token");

    let versioncheck = /^[1-9]\d*(\.\d+)?$/;

    let objArr = {};
    if (this.state.selectedFile != '') {
      formData.append('document', this.state.selectedFile);
      // objArr = {...objArr, ['document'] : aa }  
      this.setState({ errorfile: false });
    }
    else {
      this.setState({ errorfile: true });
    }
    if (this.state.documentVersion != '') {
      if (!versioncheck.test(this.state.documentVersion)) {
        this.setState({ errordocumenttype: true, errordocumentVersion: false });
      }
      else {
        formData.append('document_version', this.state.documentVersion);
        this.setState({ errordocumentVersion: false });
      }

    }
    else {
      this.setState({ errordocumentVersion: true });
    }
    if (this.state.documentName.trim() != '') {
      formData.append('document_name', this.state.documentName);
      // objArr = {...objArr, ['document_name'] : this.state.documentName }    
      this.setState({ errordocumentName: false });
    }
    else {
      this.setState({ errordocumentName: true });
    }
    const requestOptions = {
      method: "POST",
      mode: "cors",
      headers: {
        'Authorization': 'Bearer' + get_token,
        //'Content-Type': 'multipart/form-data', 
        //'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: formData,
    };

    if (this.state.documentVersion != '' && this.state.documentName.trim() != '' && this.state.selectedFile != '' && !this.state.errorfileext && !this.state.errordocumenttype && !this.state.errorfilesize) {
      { this.setState({ isdocumentLoader: true }) }
      fetch(`./wp-json/asd/api/documents`, requestOptions)
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else if (response.status === 401 || response.status === 403) {
            this.setState({ issucessMEssage: "You have been logged out, please login again", isdocumentLoader: false, errorstatuscode: '', });
            localStorage.removeItem("token");
            window.location.href = "/asd-login";
          } else if (response.status === 404) {
            this.setState({ issucessMEssage: "There are no documents to display", isdocumentLoader: false, errorstatuscode: '404', });
            return false
          } else if (response.status === 500) {
            this.setState({ issucessMEssage: "Oh no! Something bad happened. Please come back later.. ", isdocumentLoader: false, errorstatuscode: '', });
            return false
          } else {
            this.setState({ issucessMEssage: "Something went's wrong. Please try again later", isdocumentLoader: false, errorstatuscode: '', });
          }
        })
        .then(userData => {

          this.setState({ issucessMEssage: userData.message, isdocumentLoader: false, errorstatuscode: '', });
          window.location.href = './';
        })


    }
  }
  handledocumentNameChange = (e) => {
    this.setState({ documentName: e.target.value });
    if ((e.target.value).trim() == '') {
      this.setState({ errordocumentName: true });
    }
    else {
      this.setState({ errordocumentName: false });
    }
  }
  handledocumentVersionChange = (e) => {
    this.setState({ documentVersion: e.target.value });
    let versioncheck = /^[1-9]\d*(\.\d+)?$/;
    if (!versioncheck.test(e.target.value)) {
      this.setState({
        errordocumenttype: true,
        errordocumentVersion: false
      });
    }
    else if (e.target.value == '') {
      this.setState({
        errordocumentVersion: true
      });
    }
    else {
      this.setState({ errordocumentVersion: false, errordocumenttype: false });
    }
  }

  handledocumentDownload = (e) => {

    // window.open(e.currentTarget.dataset.attr, '_blank');

    e.preventDefault();
    var anchor = document.createElement('a');
    anchor.href = e.currentTarget.dataset.attr;
    anchor.target = '_blank';
    anchor.download = e.currentTarget.dataset.filename.split('/').pop();
    anchor.click();
    return false

  }


  handledeleteDocument = (event, newValue) => {
    const get_token = localStorage.getItem("token");
    const user_id = event.currentTarget.id;

    confirmAlert({
      title: 'Confirm to delete',
      message: 'Are you sure want to delete Document?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            const requestOptions = {
              method: "DELETE",
              mode: "cors",
              headers: {
                'Authorization': 'Bearer ' + get_token,
              },
            };
            if (user_id !== '') {
              fetch(`./wp-json/asd/api/documents/` + user_id, requestOptions)
                .then(response => response.json())
                .then(userData => {
                  window.location.href = './';
                });
            }
          }
        },
        {
          label: 'No',
          onClick: () => {
            return false;
          }
        }
      ]
    });
  };

  handleactiveDocument = (event, newValue) => {
    const user_id = event.currentTarget.id;
    const get_token = localStorage.getItem("token");
    const docstatus = event.currentTarget.dataset.status;
    if (docstatus == "active") {
      confirmAlert({
        message: 'Are you sure you want to Deactive Document?',
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
              let objArr = {}
              if (docstatus == "active") {
                objArr = { ...objArr, ['status']: "deactivate" }
              }
              else {
                objArr = { ...objArr, ['status']: "active" }
              }
              const requestOptions = {
                method: "PUT",
                mode: "cors",
                headers: {
                  "Content-Type": "application/json",
                  'Authorization': 'Bearer' + get_token,
                },
                body: JSON.stringify(objArr)
              };
              if (user_id !== '') {
                fetch(`./wp-json/asd/api/documents/` + user_id, requestOptions)
                  .then(response => response.json())
                  .then(userData => {

                    this.setState({ issucessMEssage: userData.message, isdocumentLoader: false });
                    window.location.href = './';
                  });
              }
            }
          },
          {
            label: 'No',
            onClick: () => {
              return false;
            }
          }
        ]
      });
    }
    else {
      confirmAlert({
        message: 'Are you sure you want to Active Document?',
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
              let objArr = {}
              if (docstatus == "active") {
                objArr = { ...objArr, ['status']: "deactivate" }
              }
              else {
                objArr = { ...objArr, ['status']: "active" }
              }
              const requestOptions = {
                method: "PUT",
                mode: "cors",
                headers: {
                  "Content-Type": "application/json",
                  'Authorization': 'Bearer' + get_token,
                },
                body: JSON.stringify(objArr)
              };
              if (user_id !== '') {
                fetch(`./wp-json/asd/api/documents/` + user_id, requestOptions)
                  .then(response => response.json())
                  .then(userData => {

                    this.setState({ issucessMEssage: userData.message, isdocumentLoader: false });
                    window.location.href = './';
                  });
              }
            }
          },
          {
            label: 'No',
            onClick: () => {
              return false;
            }
          }
        ]
      });
    }

  };
  onFileNameChangeHandler = (e) => {
    this.setState({
      selectedFile: '',
      fileName: ''
    });
    if (e.target.value = "") {
      this.setState({ errorfile: false });
    }
    else {
      this.setState({ errorfile: true });
    }
  }


  render() {
    let InpersonateButton;
    const inpersonateUser = localStorage.getItem("inpersonate_user") ? localStorage.getItem("inpersonate_user") : '';

    if (inpersonateFlag === 'true') {
      InpersonateButton = () => {
        return (
          ''
          // <div className="inpersonate-user-section">
          //   <button onClick={handleBacktoLoginUser} className="back-btn bg-orange hover:bg-gray-100 text-gray-800 font-semibold border border-gray-400 rounded shadow text-white" data-impersonation="false" id="2">
          //     <svg className="MuiSvgIcon-root jss67 back-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true" tabIndex="-1" title="ArrowBackIos" data-ga-event-category="material-icons" data-ga-event-action="click" data-ga-event-label="ArrowBackIos"><path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"></path></svg>
          //     <span className="inpersonate-name">Back to regular user</span>
          //   </button>
          //   <span className="user-btn markdown-body reset text-gray-800 font-semibold border border-gray-400 rounded shadow">
          //     <svg className="MuiSvgIcon-root jss373 person" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation" tabIndex="-1" title="People"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"></path></svg>
          //     <span className="name">{inpersonateUser}</span></span>
          // </div>


        );
      }
    } else {
      InpersonateButton = () => {
        return ""
      }
    }

    const handleBacktoLoginUser = (event, newValue) => {
      if (event.currentTarget.attributes.getNamedItem('data-impersonation').value === "true") {
        localStorage.setItem('inpersonate', true);
      } else {
        localStorage.setItem('inpersonate', false);
      }
      const get_token = localStorage.getItem("token");
      const user_id = localStorage.getItem("userId");
      const requestOptions = {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({ get_token: get_token, user_id: user_id })
      };
      if (event.currentTarget.id != '') {

        fetch(`./wp-json/asd/users/inpersonate`, requestOptions)
          .then(response => response.json())
          .then(userData => {
            if (
              "jwt_auth_invalid_token" === userData.code ||
              "jwt_auth_bad_iss" === userData.code
            ) {
              localStorage.removeItem("token");
              window.location.href = "/asd-login";
            } else if ("jwt_auth_bad_request" === userData.code) {
              if (userData.message) {
                alert(userData.message);
              }
            } else if (userData != null) {
              if (userData.token != null) {
                localStorage.setItem('token', userData.token);
                window.location.href = './';
              }
            }
          });
      }
    };


    return (
      <div>
        <p>Manage the document for partners.</p>
        <div className="documents-wrap">
          <div className="document-wrap-blk">
            <div className="main-title">
              <p> Document & Versions</p>
            </div>
            <div className="pt-6 mt-3 float-right inpersonate-user"><InpersonateButton /></div>
            {'1' === userRole && 'false' === inpersonateFlag &&
              <div className="documnet-fields-blk">

                {this.state.isdocumentLoader ? <div className="list-download-loader"><div className="spinner"></div></div> : ''}

                <div className="row">
                  <label>Document Name <span class="required">*</span></label>
                  <input type="text" placeholder="Document Name" value={this.state.documentName} onChange={this.handledocumentNameChange} />
                  {this.state.errordocumentName ? <p className="error-msg">Please Enter Document Name</p> : ''}

                </div>
                <div className="row">
                  <label>Document Version <span class="required">*</span></label>
                  <input type="text" placeholder="Enter Version of the Document" value={this.state.documentVersion} onChange={this.handledocumentVersionChange} />
                  {this.state.errordocumentVersion ? <p className="error-msg">Please Enter Document Version</p> : ''}
                  {this.state.errordocumenttype ? <p className="error-msg">Please Enter only numeric or decimal digits</p> : ''}


                </div>
                <div className="row">
                  <label>Document File Upload <div class="tooltip"><i class="fa fa-exclamation-circle" Style="cursor:pointer" aria-hidden="true"></i>
                    <span class="tooltiptext">Only .pdf files allowed</span>
                  </div> <span class="required">*</span></label>
                  <input type="text" className="form-control" placeholder="Upload File here" value={this.state.fileName} onChange={this.onFileNameChangeHandler} disabled />
                  {this.state.errorfileext ? <p className="error-msg file-error">Please Select PDF File</p> : this.state.errorfile ? <p className="error-msg file-error">Please Upload Document</p> : this.state.errorfilesize ? <p className="error-msg file-error">File size must be greater then 0 kb.</p> : ''}
                  <i class="fa fa-times-circle-o close-btn" onClick={this.clearFile} Style="display:none" aria-hidden="true"></i>
                  <div className="button-blk">
                    {/* <span className="" Style="display:none" onClick={this.clearFile} >Clear</span> */}
                    <button className="subscribe-btn" Style="display:none;background-color: green !important;" onClick={this.onClickHandler} >Upload</button>
                    <div className="button-wrapper">
                      <span className="label browse-btn">Browse</span>
                      <input type="file" name="file" id="upload" className="upload-box" onChange={this.onChangeHandler} placeholder="Upload File" />
                    </div>

                  </div>
                </div>
              </div>
            }
            {this.state.issucessMEssage.length > 0 ? <div className="flex flex-center"><p className={this.state.errorstatuscode == "404" ? "subscribe-sent-msg no-subscribe" : "subscribe-sent-msg"}>{this.state.issucessMEssage}</p></div> : ''}
            {!this.state.issucessMEssage ?
              <div className="flex-center">
                <DocumentListView
                  userData={this.state.table.data}
                  userLoading={this.state.table.loading}
                  userRows={this.state.table.totalRows}
                  handledocumentDownload={this.handledocumentDownload}
                  handledeleteDocument={this.handledeleteDocument}
                  handlePageChange={this.handlePageChange}
                  handleactiveDocument={this.handleactiveDocument}

                /></div> : ''}
          </div>
        </div>
      </div>
    )
  }
}
export default Documents